import React from "react";
import styled, { keyframes } from "styled-components";
import Logo from "../assets/CAJ02.png";

const spin = keyframes`
  0% { transform: rotate(0deg);}
  100% { transform: rotate(360deg);}
`;

const fade = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const Wrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: white;
  animation: ${fade} 0.5s ease;
`;

const LogoImg = styled.img`
  width: 140px;
  margin-bottom: 25px;
`;

const Spinner = styled.div`
  width: 45px;
  height: 45px;
  border: 4px solid #eee;
  border-top: 4px solid #111;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 20px;
`;

const Text = styled.div`
  font-size: 14px;
  color: #555;
  letter-spacing: 1px;
`;

export default function Loader() {
  return (
    <Wrapper>
      <LogoImg src={Logo} />
      <Spinner />
      <Text>Caj Elementary School</Text>
    </Wrapper>
  );
}